import React from "react";
import Icon from "../../../components/AppIcon";
import Button from "../../../components/ui/Button";
import { useDispatch } from "react-redux";
import {
  deleteEmployeeService,
  getClientsService,
} from "redux/services/clients_service";
import { useTranslation } from 'react-i18next';

const DeleteConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  customer,
  isLoading,
  isBulkDelete = false,
  selectedCount = 0,
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  if (!isOpen) return null;

  const handleConfirm = () => {
    dispatch(deleteEmployeeService({ id: customer?.id })).then((response) => {
      if (response.payload.status == 200) {
        dispatch(getClientsService({ page: 1 }));
        onConfirm();
      }
    });
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-elevation-3 w-full max-w-md">
        {/* Header */}
        <div className="flex items-center space-x-3 p-6 border-b border-border gap-4">
          <div className="w-10 h-10 bg-error rounded-md flex items-center justify-center">
            <Icon name="AlertTriangle" size={20} color="white" />
          </div>
          <div>
            <h2 className="text-xl font-semibold text-foreground">
              {isBulkDelete ? t('deleteMultipleCustomers') : t('deleteCustomer')}
            </h2>
            <p className="text-sm text-muted-foreground">
              {t('thisActionCannotBeUndone')}
            </p>
          </div>
        </div>

        {/* Content */}
        <div className="p-6">
          {isBulkDelete ? (
            <div className="space-y-4">
              <p className="text-foreground">
                {t('areYouSureYouWantToDelete')} <strong>{selectedCount}</strong>{" "}
                {t('selectedCustomers')}
              </p>

              <div className="bg-error bg-opacity-10 border border-error border-opacity-20 rounded-md p-4">
                <div className="flex items-start space-x-3">
                  <Icon
                    name="AlertCircle"
                    size={20}
                    className="text-error flex-shrink-0 mt-0.5"
                  />
                  <div className="text-sm">
                    <p className="font-medium text-error mb-1">{t('warning')}</p>
                    <ul className="text-error space-y-1">
                      <li>{t('allCustomerDataWillBeDeleted')}</li>
                      <li>{t('associatedOrderHistoryWillBePreserved')}</li>
                      <li>{t('thisActionAffectsMultipleRecords')}</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="space-y-4">
              <p className="text-foreground">
                {t('areYouSureYouWantToDelete')} <strong>{customer.first_name}</strong>?
              </p>

              {customer && (
                <div className="bg-surface p-4 rounded-md border">
                  <div className="flex items-center space-x-3">
                    <div className="w-10 h-10 bg-primary rounded-full flex items-center justify-center">
                      <span className="text-sm font-medium text-primary-foreground">
                        {customer.first_name}
                      </span>
                    </div>
                    <div>
                      <p className="font-medium text-foreground">
                        {customer.last_name}
                      </p>
                      <p className="text-sm text-muted-foreground">
                        {customer.email}
                      </p>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="flex items-center justify-end space-x-3 p-6 border-t border-border gap-4">
         
                 <Button
            variant="destructive"
            onClick={handleConfirm}
            loading={isLoading}
            className="bg-error text-error-foreground hover:bg-error hover:bg-opacity-90"
          >
            <Icon name="Trash2" size={16} className="mr-2" />
            {isBulkDelete
              ? `${t('delete')} ${selectedCount} ${t('selectedCustomers')}`
              : t('deleteCustomer')}
          </Button>

          <button variant="outline" onClick={onClose} disabled={isLoading}>
            {t('cancel')}
          </button>

  
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;
